import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CalAngularService } from "@cvx/cal-angular";
import { lastValueFrom } from "rxjs";
import { ToStringHelper } from "src/app/helpers/ToStringHelper";
import { CampEntity } from "src/app/models/campEntity";
import { CreateCyberEventCompromisedSourcingCompanyRequest, DisplayCompromisedSourcingCompanyCriteria } from "src/app/models/cyber/CyberEventCompromisedSourcingCompanyRequest";
import { CompromisedSourcingCompanyCriteriaType } from "src/app/models/cyber/enums/CyberEventCriteriaType";
import { CampService } from "src/app/services/campService/campService";
import { environment } from 'src/environments/environment';

@Component({
    selector: 'request-details-compromised-sourcing-company-create',
    templateUrl: './request-details-compromised-sourcing-company-create.component.html'
})

export class RequestDetailsCompromisedSourcingCompanyCreate implements OnInit {

    @Input() requestData: CreateCyberEventCompromisedSourcingCompanyRequest;

    @Output() doneLoading = new EventEmitter<boolean>();
    criteriaDisplayColumns: string[] = ['userType', 'criteriaType', 'value', 'displayName'];
    displayCriteria: DisplayCompromisedSourcingCompanyCriteria[] = [];
    errorMessage: string = "";
    isSearching = false;
    searchResults: CampEntity[] = [];
    constructor(private campService: CampService, private authService: CalAngularService) {

    }

    async ngOnInit() {
        this.isSearching = true;
        let ids = Array.from(new Set(this.requestData.criteria
            .filter(c => c.criteriaType === CompromisedSourcingCompanyCriteriaType.SourcingCompanyId)
            .map(c => c.value)));
  
        if (ids.length === 0) {
            this.displayCriteria = this.requestData.criteria.map(c => 
                new DisplayCompromisedSourcingCompanyCriteria(c.userType, c.criteriaType, c.value, c.value)
            );
            this.doneLoading.emit(true);
            return;
        }

        try {
            const token = await lastValueFrom(this.authService.getAADToken(environment.tokenScopes));
            
            // Make parallel calls for each ID
            const promises = ids.map(id => 
                lastValueFrom(this.campService.GetCampEntity(`id=${id}`, token))
            );

            // Wait for all calls to complete
            const results = await Promise.all(promises);
            
            // Flatten results array since each call returns an array
            this.searchResults = results.flat() as CampEntity[];

            this.displayCriteria = this.requestData.criteria.map(c => {
            if (c.criteriaType === CompromisedSourcingCompanyCriteriaType.SourcingCompanyId) {
                let entity = this.searchResults.find(e => e.id === c.value);
                if (entity) {
                ToStringHelper.overrideToString(entity);
                return new DisplayCompromisedSourcingCompanyCriteria(c.userType, c.criteriaType, c.value, entity.toString());
                }
                return new DisplayCompromisedSourcingCompanyCriteria(c.userType, c.criteriaType, c.value, "Company not found");
            }
            return new DisplayCompromisedSourcingCompanyCriteria(c.userType, c.criteriaType, c.value, c.value);
            });

            this.errorMessage = "";
        } catch (err: any) {
            this.errorMessage = err.error?.message || err.message;
        } finally {
            this.isSearching = false;
            this.doneLoading.emit(true);
        }
    }
}